(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/use-cant-buy.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/use-cant-buy.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const _svs$components$marke = svs.components.marketplaceData.constants.groupTypeNames,
  RETAILER = _svs$components$marke.RETAILER,
  PRIVATE = _svs$components$marke.PRIVATE;
const useHasReachedMaxFractionsPerMember = _ref => {
  let group = _ref.group,
    maxFractions = _ref.maxFractions,
    maxFractionsPerMember = _ref.maxFractionsPerMember,
    currentUserNumberOfShares = _ref.currentUserNumberOfShares;
  if (!group.type) {
    return undefined;
  }
  let calcHasReachedMaxFractionsPerMember;
  switch (group.type) {
    case RETAILER:
      calcHasReachedMaxFractionsPerMember = maxFractions - currentUserNumberOfShares < 1;
      break;
    case PRIVATE:
      calcHasReachedMaxFractionsPerMember = maxFractionsPerMember - currentUserNumberOfShares < 1;
      break;
    default:
      throw new Error('unknown group type');
  }
  return calcHasReachedMaxFractionsPerMember;
};
const useCantBuy = _ref2 => {
  let group = _ref2.group,
    fractionPaymentInProgress = _ref2.fractionPaymentInProgress,
    game = _ref2.game,
    currentUserNumberOfShares = _ref2.currentUserNumberOfShares;
  const maxFractionsPerMember = game.maxFractionsPerMember,
    maxFractions = game.maxFractions,
    buyStop = game.buyStop,
    isSubmitted = game.isSubmitted,
    isSoldOut = game.isSoldOut;
  const getDiffDateFromNow = date => date.getTime() - Date.now();
  const _useState = useState(buyStop && getDiffDateFromNow(buyStop) > 0),
    _useState2 = _slicedToArray(_useState, 2),
    isBeforeBuyStop = _useState2[0],
    setIsBeforeBuyStop = _useState2[1];
  const _useState3 = useState(buyStop),
    _useState4 = _slicedToArray(_useState3, 2),
    buyStopState = _useState4[0],
    setBuystopState = _useState4[1];
  const hasReachedMaxFractionsPerMember = useHasReachedMaxFractionsPerMember({
    group,
    maxFractions,
    maxFractionsPerMember,
    currentUserNumberOfShares
  });
  const timeoutToBuyStop = useRef();
  useEffect(() => {
    if (buyStop !== buyStopState && buyStop > new Date()) {
      setIsBeforeBuyStop(true);
      setBuystopState(buyStop);
    }
  }, [buyStop, buyStopState]);
  useEffect(() => {
    const ttl = buyStop ? getDiffDateFromNow(buyStop) : 0;
    if (ttl > 0) {
      if (!timeoutToBuyStop.current && ttl < 86400000) {
        timeoutToBuyStop.current = setTimeout(() => setIsBeforeBuyStop(false), ttl);
      }
    }
    return () => {
      if (timeoutToBuyStop.current) {
        clearTimeout(timeoutToBuyStop.current);
      }
    };
  }, [buyStop]);
  return hasReachedMaxFractionsPerMember || isSoldOut || !isBeforeBuyStop || fractionPaymentInProgress || Boolean(isSubmitted);
};

setGlobal('svs.components.marketplace.fractionPayment', {
  useCantBuy,
  useHasReachedMaxFractionsPerMember
});

 })(window);